import React from "react";

export const formatChoices = choices => {
    return choices;
};

class EventCoupon extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            choices: props.choices
        };
    }
    handlePriceChange = index => e => {
        const newChoices = this.state.choices.map((choice, sidx) => {
            if (index !== sidx) return choice;
            return { ...choice, price: e.target.value };
        });
        this.setState({ choices: newChoices });
    };
    handleNameChange = index => e => {
        const newChoices = this.state.choices.map((choice, sidx) => {
            if (index !== sidx) return choice;
            return { ...choice, name: e.target.value };
        });
        this.setState({ choices: newChoices });
    };
    handleDetailChange = index => e => {
        const newChoices = this.state.choices.map((choice, sidx) => {
            if (index !== sidx) return choice;
            return { ...choice, detail: e.target.value };
        });
        this.setState({ choices: newChoices });
    };
    handleAmountChange = index => e => {
        const newChoices = this.state.choices.map((choice, sidx) => {
            if (index !== sidx) return choice;
            return { ...choice, amount: e.target.value };
        });
        this.setState({ choices: newChoices });

    };

    handleRemoveChoice = index => () => {
        this.setState({
            choices: this.state.choices.filter((choice, sidx) => index !== sidx)
        });
    };

    handleAddChoice = () => {
        this.setState({
            choices: this.state.choices.concat([{ name: "", price: 0, amount: 1 , detail: ""}])
        });
    };

    render() {
        const { handleSubmit } = this.props;
        const { choices } = this.state;

        return (
            <form
                onSubmit={handleSubmit(
                    formatChoices(this.state.choices)
                )}
            >
                {
                    choices.map((choice, index) => (
                        <div key={["choice", index].join("__")}>
                            <input
                                type="text"
                                className="__textBoxSmall"
                                value={choice.name}
                                onChange={this.handleNameChange(index)}
                                onMouseLeave={handleSubmit(
                                    formatChoices(this.state.choices)
                                )}
                                placeholder="שם קופון"
                            />
                            <input
                                type="text"
                                className="__textBoxSmall"
                                value={choice.detail}
                                onChange={this.handleDetailChange(index)}
                                onMouseLeave={handleSubmit(
                                    formatChoices(this.state.choices)
                                )}
                                placeholder="הערות לצפיית לקוח"
                            />
                            <button
                                className="button"
                                onClick={this.handleRemoveChoice(index)}
                                type="submit" >
                                מחיקה
                            </button>
                        </div>
                    ))
                }
                <button className="button" type="button" onClick={this.handleAddChoice}>
                    הוסף קופון
                </button>
                <button className="button_b" type="submit">רענן</button>
            </form>
        );
    }
}

export default EventCoupon;
